<template>
  <div id="column-days">

    <template v-if="Object.keys($props.data.toWorkBeforeDayGroupedByColor.works).length > 0">
      <RenderDay
        :data="$props.data.toWorkBeforeDayGroupedByColor"
        @filesReadyToDownload="readFilesReadyToDownload"
      />
    </template>

    <template v-if="Object.keys($props.data.toWorkInTheDayGroupedByColor.works).length > 0">
      <RenderDay
        :data="$props.data.toWorkInTheDayGroupedByColor"
        @filesReadyToDownload="readFilesReadyToDownload"
      />
    </template>

    <template v-if="Object.keys($props.data.toWorkGroupedByColor.works).length > 0">
      <template v-for="(day, index) in toWorkGroupedByColor.days" :key="index">
        <RenderDay
          :data="day"
          @filesReadyToDownload="readFilesReadyToDownload"
        />
      </template>
    </template>

  </div>

</template>

<script>
import RenderDay from "@/components/cam/RenderDay";
import {computed, reactive, toRaw} from "vue";
import moment from "moment";

export default {
name: "Day",
components: {
  RenderDay,
},
props: [
  'data',
],
emits: [
  'filesToDownload',
],
setup(props, {emit}) {
  const toWorkGroupedByColor = computed(() => {
    let newDataStructure = {
      days: []
    }

    const entries = Object.entries(props.data.toWorkGroupedByColor.works);
    const sortedEntries = entries.sort((a, b) => {
      const dateA = moment(a[0], "DD/MM/YYYY");
      const dateB = moment(b[0], "DD/MM/YYYY");
      return dateA.diff(dateB);
    });

    sortedEntries.forEach((el) => {
      let date = el[0];
      let assets = toRaw(el[1]);

      let obj = {
        works: {
          [date]: []
        }
      }

      assets.forEach((asset) => {
        obj.works[date].push(asset);
      });

      newDataStructure.days.push(obj);
    });

    return reactive(newDataStructure);
  });

  const readFilesReadyToDownload = (filesToDownload) => {
    emit('filesToDownload', filesToDownload);
  }

  return {
    readFilesReadyToDownload,
    toWorkGroupedByColor,
  }
}
}
</script>

<style scoped>
#column-days {
overflow-x: auto;
overflow-y: hidden;
white-space:nowrap;
height: 100%;
width: 100%;
display: flex;
}
#wrapper {
width: 30rem;
}
</style>
